export enum Bandeira {
  CASAS_BAHIA = 1,
  PONTO = 2,
  EXTRA = 23
}
